import type { LocalePrefixMode } from 'next-intl/routing';

export const LOCALES = ['en'] as const;

export const LANGUAGE_LABELS: Record<string, string> = {
  en: 'English',
};

export const LANGUAGE_OPTIONS = LOCALES.map(locale => ({
  value: locale,
  label: LANGUAGE_LABELS[locale] || locale,
}));

export const localePrefix: LocalePrefixMode = 'as-needed';

export const nextIntlConfig = {
  locales: [...LOCALES] as const,
  defaultLocale: 'en' as const,
  localePrefix,
  // pathnames,
  alternateLinks: false,
};

export const AppRoutes = {
  home: '/',
  gameBase: '/game',
  gamesId: (id: string) => `/game/${id}`,
  profile: '/profile',

  categoryId: (categoryId: string) => `/category/${categoryId}`,
  categoryIdPaged: (categoryId: string, page = 1) => page <= 1 ? `/category/${categoryId}` : `/category/${categoryId}/${page}`,

  // seo routes
  slots: '/slots',
  slotsSlug: (slugOrId: string) => `/slots/${slugOrId}`,

  categories: '/categories',
  categoriesSlug: (slugOrId: string) => `/categories/${slugOrId}`,
  categoriesSlugPaged: (slugOrId: string, page = 1) => page <= 1 ? `/categories/${slugOrId}` : `/categories/${slugOrId}/${page}`,

  providers: '/providers',
  providersSlug: (slugOrId: string) => `/providers/${slugOrId}`,
  providersSlugPaged: (slugOrId: string, page = 1) => page <= 1 ? `/providers/${slugOrId}` : `/providers/${slugOrId}/${page}`,

  install: '/install',
  installSlug: (slug: string) => `/install/${slug}`,

  fairPlay: '/fair-play',
  fairPlayPage: (id: string) => `/fair-play/${id}`,
} as const;
